import io from "socket.io-client";
import { getUrl } from "@/common/config";

const webSocketHost = getUrl().replace("https://", "wss://").replace("http://", "ws://");

export default io(webSocketHost, { path: "/rt-api/socket.io", transports: ["websocket"] });
